import { Injectable } from '@angular/core';
import { BaseService } from '@app/core/services/base/base.service';
import { Observable } from 'rxjs';
import { InfoDialogComponent} from '@app/shared/dialogs/info-dialog/info-dialog.component';
import { ConfirmModalComponent} from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { SimpleConfirmSnackbarComponent} from '@app/shared/components/snackbar/simple-confirm/simple-confirm-snackbar.component';
import { SimpleErrorSnackbarComponent} from '@app/shared/components/snackbar/simple-error/simple-error-snackbar.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService extends BaseService {

    constructor(protected dialog: MatDialog, protected snackBar: MatSnackBar) {
        super();
    }

    public showSimpleInfoDialog(title: string, text: string | string[], width?: string): Observable<any> {
        width = width ? width : '250px';
        const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: width,
            data: {
                title: title,
                text: text
            }
        });

        return dialogRef.afterClosed();
    }

    public showSimpleConfirmDialog(title: string, text: string | string[], width?: string): Observable<any> {
        width = width ? width : '250px';
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            width: width,
            data: {
                title: title,
                text: text
            }
        });

        return dialogRef.afterClosed();
    }

    public showSimpleConfirmSnackbar(message: string, duration = 3000): void {
        this.snackBar.openFromComponent(SimpleConfirmSnackbarComponent, {
            data: {
                message: message
            },
            duration: duration,
            panelClass: ['smp-snackbar', 'smp-confirm-snackbar']
        });
    }

    public showSimpleErrorSnackbar(message: string, duration = 5000): void {
        this.snackBar.openFromComponent(SimpleErrorSnackbarComponent, {
            data: {
                message: message
            },
            duration: duration,
            panelClass: ['smp-snackbar', 'smp-error-snackbar']
        });
    }
}

